export default "__VITE_PUBLIC_ASSET__31801e6d__"